import { render } from "./TextHighlights.vue?vue&type=template&id=6a5dd8d0&ts=true"
import script from "./TextHighlights.vue?vue&type=script&lang=ts"
export * from "./TextHighlights.vue?vue&type=script&lang=ts"

import "./TextHighlights.vue?vue&type=style&index=0&id=6a5dd8d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__